module.exports = __webpack_public_path__ + "static/media/arnxm.d42fc27c.svg";